import type { ConfigInterface, NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useProvider } from '@newfront-insurance/react-provision';
import { useMemo } from 'react';

import { routes } from '../../bff/routes';
import type { Employee } from '../../bff/types';
import { LayoutConfigProvider } from '../config';

export function useEmployeesByUserUuids(
  userUuids: string[],
  config?: ConfigInterface,
): NextApiSubscription<Employee[] | null> {
  const { apiBasePath: basePath } = useProvider(LayoutConfigProvider);
  const url = useMemo(() => {
    const uniqueUserUuids = [...new Set(userUuids.filter(Boolean))];
    if (uniqueUserUuids.length === 0) {
      return null;
    }

    const queryParams = new URLSearchParams();
    uniqueUserUuids.forEach((userUuid) => queryParams.append('userUuids', userUuid));

    return `${routes.getEmployeesByUserUuids.getUrl({ basePath })}?${queryParams.toString()}`;
  }, [basePath, userUuids]);

  return useNextApiSubscription<Employee[] | null>(url, config);
}
